<template>
  <div class="result__send">
    <button class="result__button" @click="sendEmail"><i></i>Enviar detalle valoración</button>
    <Popup
      v-if="popupType"
      :title="popupTitle"
      :subtitle="popupSubtitle"
      :modifier-class="popupType"
      :color="popupColor"
      :showCloseIcon="true"
      :showHeaderIcon="true"
      @closePopup="closePopup"
    >
      <DetailForm v-if="showSendPopup" action="saveUser" :errors="formErrors" @saveUser="submit" @closePopup="closePopup"></DetailForm>
      <Success v-if="showSuccessPopup" @closePopup="closePopup"></Success>
    </Popup>
  </div>
</template>

<script>
import axios from 'axios';
import Popup from '@/funnels/components/layout/Popup';
import Success from '@/web/calculator/popup/Success';
import DetailForm from '@/web/calculator/popup/DetailForm';

const DETAIL = 'detail';
const DETAIL_SUCCESS = 'detail_success';

export default {
  components: { Popup, Success, DetailForm },
  props: { cadastralReference: String },
  data() {
    return {
      formErrors: null,
      form: {},
      scrollTriggered: false,
      popupType: null,
      popupData: {
        [DETAIL]: {
          title: 'Recibe el detalle de tu valoración',
          subtitle: 'Necesitamos algunos datos para enviarte los resultados.',
        },
        [DETAIL_SUCCESS]: {
          title: '¡Revisa tu email!',
          subtitle: 'Te hemos enviado el resultado completo a tu correo electrónico, ¡así siempre lo tendrás a mano!',
        },
      },
    };
  },
  computed: {
    showSendPopup() {
      return this.popupType === DETAIL;
    },
    showSuccessPopup() {
      return this.popupType === DETAIL_SUCCESS;
    },
    popupTitle() {
      return this.popupType ? this.popupData[this.popupType].title : '';
    },
    popupSubtitle() {
      return this.popupType ? this.popupData[this.popupType].subtitle : null;
    },
    popupColor() {
      return this.showSendPopup ? 'moles--info' : 'moles--success';
    },
  },
  methods: {
    sendEmail() {
      this.popupType = DETAIL;
    },
    submit(user) {
      this.form = user;

      axios
        .post(window.location.pathname + '/email', { ...this.form, ...{ property: this.cadastralReference } })
        .then(() => {
          this.popupType = DETAIL_SUCCESS;
        })
        .catch(e => {
          if (e.response && e.response.data && e.response.data.errors) {
            this.formErrors = e.response.data.errors;
          }
        });
    },
    closePopup() {
      this.popupType = null;
    },
    onScrollToTarget(target, cb) {
      window.addEventListener('scroll', () => {
        const rect = target.getBoundingClientRect();

        if (rect.top < 0 && !this.scrollTriggered) {
          cb();
          this.scrollTriggered = true;
        } else if (rect.top > 0) {
          this.scrollTriggered = false;
        }
      });
    },
  },
  mounted() {
    this.onScrollToTarget(document.querySelector('#scroll-target'), () => (this.popupType = DETAIL));
  },
};
</script>
